import { useEffect, useState } from 'react';
import api from '../../lib/api';

export default function FinanceDashboard(){
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(()=>{ 
    (async()=>{
      try {
        const response = await api.get('/fees/quote', {
          params: { 
            country:'BS', 
            method:'stripe', 
            role:'landlord', 
            amount_cents: 100000, 
            currency:'USD' 
          }
        });
        setQuote(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    })();
  },[]);
  
  if (loading) return <div className="p-6">Loading...</div>;
  if (error) return <div className="p-6 text-red-600">Error: {error}</div>;
  
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Finance Control Panel</h1>
        <p className="text-gray-600 mt-1">Manage payout fees, routing rules, and financial settings</p>
      </div>
      
      <div className="bg-white border rounded-lg p-6">
        <h2 className="text-lg font-semibold mb-4">Fee Quote Example (Bahamas, $1,000)</h2>
        
        {quote && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded">
                <div className="text-sm text-blue-600 font-medium">Payment Method</div>
                <div className="text-xl font-bold text-blue-900 capitalize">{quote.method}</div>
              </div>
              <div className="bg-green-50 p-4 rounded">
                <div className="text-sm text-green-600 font-medium">Country</div>
                <div className="text-xl font-bold text-green-900">{quote.country}</div>
              </div>
            </div>
            
            <div className="bg-gray-50 p-4 rounded">
              <div className="text-sm text-gray-600 font-medium mb-3">Fee Breakdown</div>
              <table className="w-full">
                <tbody className="text-sm">
                  <tr className="border-b">
                    <td className="py-2 text-gray-700">Payout Amount</td>
                    <td className="py-2 text-right font-semibold">${(quote.amount_cents / 100).toFixed(2)}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600">Base Fee</td>
                    <td className="py-2 text-right">${(quote.base_fee_cents / 100).toFixed(2)}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600">Processing Fee</td>
                    <td className="py-2 text-right">${(quote.percent_fee_cents / 100).toFixed(2)}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600">Cross-Border Fee</td>
                    <td className="py-2 text-right">${(quote.cross_border_fee_cents / 100).toFixed(2)}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600">FX Markup</td>
                    <td className="py-2 text-right">${(quote.fx_fee_cents / 100).toFixed(2)}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 text-gray-600">Platform Markup</td>
                    <td className="py-2 text-right">${(quote.platform_markup_cents / 100).toFixed(2)}</td>
                  </tr>
                  <tr className="border-t-2 border-gray-300">
                    <td className="py-2 font-bold text-gray-900">Total Fees</td>
                    <td className="py-2 text-right font-bold text-red-600">${(quote.total_fee_cents / 100).toFixed(2)}</td>
                  </tr>
                  <tr className="bg-green-100">
                    <td className="py-2 font-bold text-gray-900">Net Amount to Landlord</td>
                    <td className="py-2 text-right font-bold text-green-700 text-lg">${(quote.net_amount_cents / 100).toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded p-3">
              <p className="text-sm text-yellow-800">
                <strong>Platform Revenue:</strong> ${(quote.total_fee_cents / 100).toFixed(2)} per $1,000 payout
              </p>
            </div>
          </div>
        )}
      </div>
      
      <div className="bg-white border rounded-lg p-6">
        <h2 className="text-lg font-semibold mb-3">Fee & Routing Management</h2>
        <p className="text-gray-600 mb-4">Configure fee schedules, routing rules, and provider settings.</p>
        <div className="text-sm text-gray-500">
          Coming soon: CRUD interfaces for fee rules and routing configuration
        </div>
      </div>
    </div>
  );
}
